module.exports = __webpack_public_path__ + "assets/target-9bc76e.svg";